"use client";
import Image from "next/image";
import React from "react";
import Marquee from "react-fast-marquee";
import {
  CommonBooks1,
  CommonBooks2,
  CommonBooks3,
  CommonBooks4,
  CommonBooks5,
  CommonBooks6,
  CommonBooks7,
  CommonBooks8,
  CommonBooks9,
  CommonBooks10,
} from "@/assets";
import { fontSizes } from "@/constants/constants";

const rowA = [CommonBooks1, CommonBooks2, CommonBooks3, CommonBooks4, CommonBooks5];
const rowB = [CommonBooks6, CommonBooks7, CommonBooks8, CommonBooks9, CommonBooks10];

const Cover = ({ src }) => (
  <div className="group mx-3 w-40 flex-shrink-0 overflow-hidden rounded-xl ring-1 ring-white/10 transition-all duration-500 hover:-translate-y-2 hover:ring-gold/50 md:w-48">
    <Image src={src} alt="Published book cover" className="h-full w-full object-cover" />
  </div>
);

const BooksShowcase = ({ title, description }) => {
  return (
    <section className="relative w-full overflow-hidden bg-ink bg-paper-grain py-16 md:py-20">
      <div aria-hidden className="pointer-events-none absolute -left-20 top-10 h-60 w-60 rounded-full bg-brand-500/20 blur-3xl" />
      <div aria-hidden className="pointer-events-none absolute -right-16 bottom-10 h-60 w-60 rounded-full bg-gold/10 blur-3xl" />

      <div className="relative mx-auto mb-12 max-w-3xl px-4 text-center text-white">
        <span className="eyebrow mx-auto mb-4 flex items-center justify-center gap-3 text-gold-soft">
          <span className="h-px w-8 bg-gold/70" />
          Our Portfolio
          <span className="h-px w-8 bg-gold/70" />
        </span>
        <h2 className={`font-display font-semibold leading-tight ${fontSizes.text_4_xl}`}>{title}</h2>
        <p className={`mx-auto mt-4 max-w-2xl leading-relaxed text-white/70 ${fontSizes.base}`}>{description}</p>
      </div>

      <div className="relative space-y-5">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-ink to-transparent md:w-40" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-ink to-transparent md:w-40" />
        <Marquee speed={40} gradient={false} pauseOnHover autoFill>
          {rowA.map((src, i) => (
            <Cover key={`a-${i}`} src={src} />
          ))}
        </Marquee>
        <Marquee speed={40} direction="right" gradient={false} pauseOnHover autoFill>
          {rowB.map((src, i) => (
            <Cover key={`b-${i}`} src={src} />
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default BooksShowcase;
